import { createApp } from '@app/adapters/create-app'
import RemarkTagForm from '@app/templates/components/remark-tag-form.vue'

export default (): void => {
  window.onDomLoad(($dom) => {
    $dom.find("[data-behaviour='remark-tag-form']").each((_, form) => {
      const data = form.dataset
      createApp(RemarkTagForm, {
        countMessage: data.countMessage,
        errors: JSON.parse(data?.errors || ''),
        initialValue: data.initialValue,
        submitLabel: data.submitLabel,
        title: data.title,
      }).mount(form)
    })
  })
}
